document.addEventListener('DOMContentLoaded', function (event) {
  initalizeZoomImage();
});

function initalizeZoomImage() {
  const maxHeight = 0.8;

  const images = document.querySelectorAll('.ZoomImage-wrapper');

  images.forEach((image) => {
    const button = image.querySelector('.ZoomImage-button');

    button.addEventListener('click', (e) => {
      const imageEl = image.querySelector('.ZoomImage-image img');
      const wrap = document.querySelector('.ZoomImage-image');
      const button = e.currentTarget;
  
      if (imageEl.width <= imageEl.naturalWidth) {
        if (!wrap.classList.contains("ZoomImage--zoomed")) {
          wrap.classList.add("ZoomImage--zoomed");
          button.querySelector('.ZoomImage-button-label').textContent = button.dataset.zoomout;
        } else {
          wrap.classList.remove("ZoomImage--zoomed");
          button.querySelector('.ZoomImage-button-label').textContent = button.dataset.zoomin;
        }
      }
    });
  });
}
